import { render, staticRenderFns } from "./ShBudgetProcedure.vue?vue&type=template&id=1bdf8228&"
import script from "./ShBudgetProcedure.vue?vue&type=script&lang=js&"
export * from "./ShBudgetProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports